// extracted by mini-css-extract-plugin
module.exports = {"outer_1MjL_A":"outer_1MjL_A","tooltip_TQe9Fo":"tooltip_TQe9Fo","tooltip-position-right_1j4yCN":"tooltip-position-right_1j4yCN"};